// Copyright (c) Microsoft. All rights reserved.

import { FC } from 'react';
import Image from '../Image';

interface ILoadingProps {
  text: string;
}

export const Loading: FC<ILoadingProps> = ({ text }) => {
  return (
    <div className="loading">
      <Image url="etc-icons/loading_apng_F.png" className="loading-icon" />
      {text}
    </div>
  );
};
